export default function resolveEnv(name) {
  return window?.configs?.[name] || process.env[name];
}
